import { notification } from "antd";

type NotificationType = "success" | "info" | "warning" | "error";

interface NotificationProps {
  type: NotificationType;
  title: string;
  description: string;
}

export const showNotification = ({
  type,
  title,
  description,
}: NotificationProps) => {
  notification[type]({
    message: title,
    description,
  });
};
